import { Select } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { UnitTag } from "@msuite/ui/tag";
import { getUnitTranslationKey } from "@msuite/utils/strings";
import type { Enums } from "@msuite/utils/types";
import { useFormContext } from "react-hook-form";

/** Props Interface */
interface UnitPickerProps {
	options: Readonly<Enums<"unit">[]>;
	name?: string;
	isDisabled?: boolean;
}

function UnitPicker({ options, name = "unit", isDisabled }: UnitPickerProps) {
	/** Hooks */
	const methods = useFormContext<{ unit: string }>();
	const { t } = useTranslation();

	/** Render */
	return (
		<Select
			control={methods.control}
			name={name as any}
			label={t("units.unit")}
			isRequired
			isNullable={false}
			placeholder={t("general.select")}
			options={options.map((unit) => ({
				label: t(getUnitTranslationKey(unit as Enums<"unit">)),
				value: unit,
				item: {
					unit,
				},
			}))}
			itemNotFoundLabel={t("general.not_found")}
			renderOption={(_, __, value) => {
				return <UnitTag unit={value as Enums<"unit">} />;
			}}
			data-cy="unit-picker"
			isDisabled={isDisabled}
		/>
	);
}

export { UnitPicker };
